import { useEffect, useState } from "react";
import "../css/Dashboard.css"
import { Dialog } from "primereact/dialog";
import CropAvatarPic from "./CropWatermarkPic";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../apiClient";
import colors from '../colors';

function ManageWatermark(props)
{
    const [showEditWatermark, setShowEditWatermark] = useState(false);
    const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);
    const [cropPic,setCropPic] = useState(false);
    const [theme,setTheme] = useState();
    const navigate = useNavigate();
    const token = JSON.parse(localStorage.getItem('userToken'));
    const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
    const [watermark,setWatermark] = useState("");
    const [updateWatermark,setUpdateWatermark] = useState(0);
    const closeCropPic = async () => {
        
          setCropPic(false);
          await setUpdateWatermark(updateWatermark+1);
   
      };


      //get watermark pic:
        useEffect(() => {
         
          apiClient.get(process.env.REACT_APP_BACK + "/users/getUserWatermark/" + props.user_id, config)
          .then(async(response) => {

            await setWatermark(response.data);
              
          })
          .catch((error) => {
            
          });


        }, );

    return(
        <div id="manage-pages">
            <h2>
            واترمارک
            </h2>

            <p>تصویر واترمارک خود را آپلود کنید</p>

            <span className="p-col1" style={{display:"flex",justifyContent:"center"}}>

          <span style={{display:"flex",width:"fit-content"}}>
          <div className="p-avatarPic"
               onMouseEnter={() => { setShowEditWatermark(true) }}
              onMouseLeave={() => { setShowEditWatermark(false) }}
              onClick={() => setCropPic(true)}
              style={{
                background: "#ffffff",
                borderRadius: "10px",
                boxShadow: "0 1px 4px rgba(0, 0, 0, 0.15)",
                width: "500px",
                height: "500px",
              }}
            >

              
              <div
                id="edit-profile-pic"
                style={{
                  // display: ( showEditWatermark || !desktop) ? "block" : "none",
                  background: desktop ? "#25252580" : "#25252520",
                  borderRadius: "10px",
                  marginTop: "0px",
                  width: "500px",
                  height: "500px",
                  position: "absolute",
                  cursor: "pointer",
                }}
              >
                <i
                  className="pi pi-camera"
                  style={{
                    marginTop: "40%",
                    fontSize: "100px",
                    color: "#ffffff",
                  }}
                ></i>
              </div>
              
              { watermark!=="" && (
              <img 
              src={ `${process.env.REACT_APP_BACK}/watermarks/${watermark}`}
              alt={process.env.REACT_APP_ALT}
              >
              </img>
              )}

              
          
            </div>
            </span>

            <span style={{display:"flex",width:"fit-content"}}>
            <div  className="p-title" style={{ textAlign: "right", margin: "-20px 10px 0px 0px" }}>

            <span style={{display:"flex",alignItems:"center",direction:"rtl",marginTop:"30px"}}>
                    
                    
                    </span>
              
              
            </div>
            </span>

          </span>

            
            
        <Dialog
        id="crop-profile"
        className={theme}
        header="آپلود تصویر واترمارک"
        visible={cropPic}
        onHide={() => setCropPic(false)}
        
      >
        <CropAvatarPic  user_id={props.user_id} close={closeCropPic}/>
      </Dialog>



        </div>
    );
}

export default ManageWatermark;